<template>
  <Modal
    class="common-drawer mainversion newModal"
    v-model="isShow"
    class-name="constabook"
    title="版本更新记录"
    width="1000"
    :mask-closable="false"
    @on-cancel="closeModal"
  >
    <div class="common-list table-margin">
      <Table
        class="equipmentTable"
        :columns="dataColumn"
        :data="dataLists"
      ></Table>
    </div>
    <div class="common-page fr">
      <!--  -->
      <Page
        show-total
        show-elevator
        :total="total"
        @on-page-size-change="getListsSize"
        show-sizer
        :current="pageInfo.current"
        :page-size="pageInfo.size"
        @on-change="getList"
      >
      </Page>
    </div>
    <div class="drawer-footer" slot="footer"></div>
  </Modal>
</template>
  
  <script>
import api from "@/api";
import sizeData from "@/mixins/sizeData";
import handleSelItem from "@/mixins/handleSelItem";
import toRoleName from "@/mixins/roleName";
import ls from "store2";
import { mapState } from "vuex";
import Base64 from "@/util/encryptlong";
export default {
  mixins: [handleSelItem, sizeData, toRoleName],
  props: ["showvModal"],
  computed: {},
  data() {
    return {
      isShow: false,
      userInfo: JSON.parse(Base64.decode(ls.page("userInfo"))) || {},
      userRole: null,
      dataLists: [],
      pageInfo: {
        current: 1,
        size: 10,
      },
      total: 0,
      dataColumn: [
        {
          title: "序号",
          type: "index",
        },
        {
          title: "版本号",
          key: "code",
          align: "left",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.code || "-");
          },
        },
        {
          title: "版本更新内容",
          key: "content",
          align: "left",
          render: (h, params) => {
            const item = params.row;
            return h(
              "div",
              { class: "comment tab-linheight maiver" },
              item.content || "-"
            );
          },
        },

        {
          title: "版本更新时间",
          key: "versionModifiedReal",
          align: "left",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.versionModifiedReal || "-");
          },
        },
      ],
    };
  },
  watch: {
    showvModal: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.isShow = newValue;
        }
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    this.isShow = this.showvModal;
    this.getList();
  },
  methods: {
    getList(page) {
      if (page) this.pageInfo.current = page; //分页处理
      api
        .axss("post", "/ocm-oil-site/oil-site-publish-version/list", {
          ...this.pageInfo,
        })
        .then((res) => {
          if (res.code === "00000") {
            this.dataLists = res.data.records;
            this.total = res.data.total;
            this.$nextTick(() => {
              var popup = document.getElementsByClassName(
                "maiver"
              );
              for (let index in popup) {
                let row = popup[index];
                const containerHeight = row.clientHeight;
                if (containerHeight && containerHeight > 22) {
                  row.style.padding = "10px 0";
                }
              }
              
            });
          }
        })
        .catch((res) => {});
    },
    closeModal() {
      this.$emit("close");
      this.isShow = false;
    },
    getListsSize(size) {
      this.pageInfo.size = size;
      this.getList(1);
    },
  },
};
</script>
  
  <style lang='less' scoped>
::v-deep .ivu-modal-body .ivu-table-wrapper {
  min-height: 100px;
  overflow-y: hidden;
}
.common-page {
  margin-bottom: 0px;
}
</style>
<style lang="less">
.comment {
  white-space: pre-wrap;
}

.mainversion .equipmentTable {
  max-height: none !important;
  overflow-x: hidden !important;
}
.mainversion .ivu-modal-wrap .ivu-modal {
  top: 100px !important ;
}
</style>